import * as yup from "yup";
import { AddressDetails, SecondaryDetails } from "../interfaces";
import regex from "../../../regex";

const initialValues: AddressDetails = {
  address: {
    address1: "",
    address2: "",
    address3: "",
    pinCode: "",
    state: "",
    stateCode: "",
    city: "",
    cityCode: ""
  }
};

const addressValidationSchema = (isPincodeInvalid: boolean, address: any) =>
  yup.object().shape<Record<keyof SecondaryDetails, yup.AnySchema>>({
    address1: yup
      .string()
      .when([], {
        is: () => address?.line1,
        then: (schema) => schema.required("Address1 is Required"),
        otherwise: (schema) => schema
      })
      .matches(regex.address1, "Invalid Address")
      .min(1, "Min 1 Characters Allowed")
      .max(30, "Max 30 Chars Allowed"),
    address2: yup
      .string()
      .when([], {
        is: () => address?.line2,
        then: (schema) => schema.required("Address2 is Required"),
        otherwise: (schema) => schema
      })
      .matches(regex.address1, "Invalid Address")
      .min(1, "Min 1 Characters Allowed")
      .max(30, "Max 30 Chars Allowed"),
    address3: yup
      .string()
      .matches(regex.address1, "Invalid Address")
      .min(1, "Min 1 Characters Allowed")
      .max(30, "Max 30 Chars Allowed"),
    pinCode: yup
      .string()
      .when([], {
        is: () => address?.pincode,
        then: (schema) => schema.required("Pincode is Required"),
        otherwise: (schema) => schema
      })
      .matches(regex.pincode, "Invalid Pincode")
      .test("is-valid-pincode", "Incorrect Pincode", () => !isPincodeInvalid),
    state: yup.string().when([], {
      is: () => address?.state,
      then: (schema) => schema.required("State is Required"),
      otherwise: (schema) => schema
    }),
    city: yup.string().when([], {
      is: () => address?.city,
      then: (schema) => schema.required("City is Required"),
      otherwise: (schema) => schema
    }),
    cityCode: yup.string(),
    stateCode: yup.string()
  });

const validationSchema = (isPincodeInvalid: boolean, address: any) =>
  yup.object().shape<Record<keyof AddressDetails, yup.AnySchema>>({
    address: addressValidationSchema(isPincodeInvalid, address)
  });

export { initialValues, addressValidationSchema, validationSchema };
